import { Stepper } from '../../modules/stepper';
import { nodeListToArray } from '../../helpers/nodeListToArray';

export const voucherPage = () => {
    const flexPanel = document.getElementById("FlexVoucherPanel");
    const bonusPanel = document.getElementById("BonusVoucherPanel");
    const flexSteppers = nodeListToArray(flexPanel.querySelectorAll('[data-stepper-voucher]'));
    const bonusSteppers = nodeListToArray(bonusPanel.querySelectorAll('[data-stepper-voucher]'));

    console.log(bonusSteppers)

    const showMoreButtons = nodeListToArray(document.querySelectorAll('[data-voucher-viewmore]'));
    flexSteppers.forEach(stepper => {
        const stepperError = document.getElementById(stepper.dataset.stepperError);
        const allStepperQuantity = document.getElementsByClassName(stepper.dataset.stepperQuantity);

        const redeemContainer = document.getElementById(stepper.dataset.redeemContainer);
        const redeemButtons = nodeListToArray(redeemContainer.querySelectorAll('button[type="submit"]'));

        const stepperObject = new Stepper(stepper, null, () => {
            redeemButtons.forEach(button => {
                button.disabled = stepperObject._numberValue <= 0;
            });
            for (var i = 0; i < allStepperQuantity.length; i++) {
                var stepperQuantity = allStepperQuantity[i] as HTMLInputElement;
                stepperQuantity.value = stepperObject._numberValue.toString();
            }
            return (stepperObject._numberValue === stepperObject.max - 1 && stepperError) ? stepperError.classList.remove('hide') : stepperError.classList.add('hide');
        });
    });


    const bonusStepperObjects = []
    bonusSteppers.forEach(stepper => {
        const stepperError = document.getElementById(stepper.dataset.stepperError);

        const redeemContainer = document.getElementById(stepper.dataset.redeemContainer);
        const voucherItems = nodeListToArray(redeemContainer.querySelectorAll('[data-voucher-item]'));

        const voucherPriceType = stepper.dataset.voucherPricetype
        const performancePriceTypes = stepper.dataset.performancePricetypes.split(",")

        const stepperObject = new Stepper(stepper, null, () => {
            voucherItems.forEach(item => {
                const itemElement = (item as HTMLElement)
                if (itemElement) {
                    //const performanceInfo = (item as HTMLElement).querySelector('.vouchers-performance-info')
                    const button = (item as HTMLElement).querySelector('button[type="submit"]') as HTMLButtonElement
                    const priceTypesElement = (item as HTMLElement).querySelector('[data-available-pricetypes]') as HTMLElement
                    const itemQuantity = itemElement.querySelector('.BonusVoucherQuantity') as HTMLInputElement
                    const itemPricetype = itemElement.querySelector('.BonusVoucherPriceType') as HTMLInputElement
                    if (priceTypesElement) {
                        const availablePriceTypes = priceTypesElement.dataset.availablePricetypes.split(",")
                        const matchingPriceTypes = availablePriceTypes.filter(pt => performancePriceTypes.includes(pt))
                        button.disabled = stepperObject._numberValue <= 0 || matchingPriceTypes.length <= 0

                        if (itemQuantity) {
                            itemQuantity.value = stepperObject._numberValue.toString()
                        }
                        if (itemPricetype) {
                            itemPricetype.value = voucherPriceType
                        }
                    }
                }
            });
            bonusStepperObjects.forEach(step => {
                const otherStepper = step as Stepper
                if (otherStepper.stepperElement.dataset.voucherPricetype
                    !== stepperObject.stepperElement.dataset.voucherPricetype) {
                    if (otherStepper._numberValue < 1) {
                        if (stepperObject._numberValue > 0) {
                            otherStepper.disable()
                        } else {
                            otherStepper.updateButtonsEnabled()
                        }
                    }
                }
            })
            return (stepperObject._numberValue === stepperObject.max - 1 && stepperError) ? stepperError.classList.remove('hide') : stepperError.classList.add('hide');
        });
        bonusStepperObjects.push(stepperObject)
    });
    showMoreButtons.forEach(button => {
        const listToUpdate = document.getElementById(button.getAttribute('data-voucher-list'));
        button.addEventListener('click', () => {
            if (listToUpdate) {
                let itemsToToggle = nodeListToArray(listToUpdate.querySelectorAll('[data-voucher-item].hide'));
                const amountToToggle = parseInt(button.getAttribute("data-voucher-amount-to-show"))
                itemsToToggle.forEach((item, index) => {
                    if (index <= amountToToggle)
                        item.classList.remove('hide');
                });
                itemsToToggle = nodeListToArray(listToUpdate.querySelectorAll('[data-voucher-item].hide'));
                if (itemsToToggle.length === 0)
                    button.classList.add('hide');
            }
        });
    });
}